import { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";

import * as AdminHandler from "../../components/js/modules/Admin";
import * as TicketHandler from "../../components/js/modules/Tickets";

import Loading from "./Loading";
import Error from "./Error";
import Dropdown from "./Dropdown";
import TextBox from "./TextBox";
import Button from "./Button";

import "../css/TicketInfo.css";

const TicketOverview = ({ticketData}) => {
    const [status, setStatus] = useState("loading");
    const [isChanged, setIsChanged] = useState(false);
    const [isTopicChanged, setIsTopicChanged] = useState(false);
    const [isOwnerChanged, setIsOwnerChanged] = useState(false);

    const [topic, setTopic] = useState({
        text: ticketData.topic,
        panel: ticketData.panel
    });
    const [owner, setOwner] = useState(ticketData.account.rbxuser.username);

    const topics = useRef();
    const ticketProgress = ticketData.status == "Archived" && "Complete" || (ticketData.status == "Active" && (ticketData.staff_ids.length == 0 && "Awaiting Staff" || "Resolving"));
    const progressColor = (ticketProgress == "Complete" && "#34c940") || (ticketProgress == "Resolving" && "#ee8449") || (ticketProgress == "Awaiting Staff" && "#c93434")

    const reset = () => {
        setTopic({
            text: ticketData.topic,
            panel: ticketData.panel
        });
        setOwner(ticketData.account.rbxuser.username);
        setIsChanged(false);
        setIsOwnerChanged(false);
        setIsTopicChanged(false);
    }

    const saveChanges = () => {
        if ((!topic && !owner) || !isChanged) return reset();
        var choseTopic = isTopicChanged && {
            panel_id: topic.panel.panel_id,
            topic: topic.text
        }
        
        AdminHandler.applyTicketSettings(choseTopic, isOwnerChanged && owner || undefined, (res) => {
            if (res.status == "error" || res.status == "invalid") {
                Swal.fire({
                    title: "Error",
                    text: "An issue occurred while trying to switch this ticket's settings.",
                    icon: "error",
                    confirmButtonText: "Ok"
                });
            } else if (res.status == "not found") {
                Swal.fire({
                    title: "Error",
                    text: "The account you searched for does not exist.",
                    icon: "error",
                    confirmButtonText: "Ok"
                });
            } else {
                Swal.fire({
                    title: "Success",
                    text: "You have updated this ticket.",
                    icon: "success",
                    confirmButtonText: "Ok"
                });
                setIsChanged(false);
                setIsOwnerChanged(false);
                setIsTopicChanged(false);
            }
        });
    }

    useEffect(() => {
        TicketHandler.getPanels()
            .then((res) => {    
                var topicList = [];
                for (const panel of res.data) {
                    for (const topic of panel.topics) {
                        topic.panel = panel;
                        topicList.push(topic);
                    }
                };

                topics.current = topicList;
                setStatus("loaded");
            })
            .catch(() => {
                setStatus("error");
            })
    }, []);

    return <>
        <h3>Ticket Overview</h3>
        
        <Loading visible={status == "loading"} noBackground={true} text="Loading Panels"/>
        <Error visible={status == "error"} noBackground={true} text="There was an issue loading panels, contact the Network Engineer."></Error>

        {status == "loaded" && topics.current && <>
            <span style={{fontSize: "1.1em"}}><i className="fa-solid fa-layer-group"></i> System</span>
            <h4>{ticketData.panel.title}</h4>

            <span style={{fontSize: "1.1em"}}><i style={{"color": progressColor}} className="fa-solid fa-circle"></i> Status</span>
            <h4>{ticketProgress}</h4>

            <span style={{fontSize: "1.1em"}}><i className="fa-solid fa-phone"></i> Support Staff</span>
            <h4>{ticketData.staff_ids[0] && ticketData.staff_ids[0].rbxuser.username || "None"}</h4>

            <span style={{fontSize: "1.1em"}}><i className="fa-solid fa-lightbulb"></i> Topic</span>
            <Dropdown
                options={topics.current.map((listTopic, _) => {
                    return {
                        value: `${listTopic.text}-${listTopic.panel.panel_id}`, 
                        label: `[${listTopic.panel.title.toUpperCase()}] ${listTopic.text}`, 
                        image: listTopic.logo,

                        topic: listTopic.text,
                        panel: listTopic.panel
                    }
                })}
                includeImages={true}
                onChange={(state) => {
                    setTopic({
                        text: state.topic,
                        panel: state.panel
                    });
                    setIsChanged(true);
                    setIsTopicChanged(true);
                }}
                disabled={!ticketData.user_permissions.canSwitchPanel}

                value={{
                    value: `${topic.text}-${topic.panel.panel_id}`,
                    label: `[${topic.panel.title.toUpperCase()}] ${topic.text}`
                }}
            ></Dropdown>

            <span style={{fontSize: "1.1em"}}><i className="fa-solid fa-circle-user"></i> User</span>
            <TextBox 
                setState={(value) => {
                    setOwner(value);
                    setIsChanged(true);
                    setIsOwnerChanged(true);
                }}
                disabled={!ticketData.user_permissions.canSwitchTicketOwner}
            >
                {owner}
            </TextBox>

            <div data-status={isChanged && "show"} style={{gap: "5px"}} className="ticket-info-row-nowrap ticket-overview-change-btns">
                <Button 
                    style={{width: '100%'}} 
                    data-size={1.2} 
                    data-animation="raise" 
                    data-style="confirm"

                    onClick={saveChanges}
                >
                    <i className="fa-solid fa-floppy-disk"></i> Save
                </Button>

                <Button 
                    style={{width: '100%'}} 
                    data-size={1.2} 
                    data-animation="raise" 
                    data-style="cancel"

                    onClick={reset}
                >
                    <i className="fa-solid fa-rotate-left"></i> Cancel
                </Button>
            </div>
        </>}
    </>
}

export default TicketOverview